import { Button } from '@evogard/ui';

/**
 * O botão "Parados" das esteiras do sinistro e de Periféricos (30/10/2026,
 * pedido do dono). Era uma opção dentro de Filtros, que mostrava só os parados
 * ou todos; virou um botão ao lado da busca, e os dois recortes passaram a ser
 * EXCLUDENTES: apagado, a esteira mostra os cards que andam; aceso, só os
 * parados (pendência, jurídico ou pedido de desistência). Não há mais a vista
 * com os dois juntos — o parado não divide a coluna com quem está em trabalho.
 */
export function HoldToggle({
  held,
  onChange,
}: {
  held: boolean;
  onChange: (held: boolean) => void;
}) {
  return (
    <Button
      variant={held ? 'primario' : 'contorno'}
      icon="pausa"
      aria-pressed={held}
      title={
        held
          ? 'Mostrando só os parados. Clique para voltar aos que não estão parados.'
          : 'Mostrando os que não estão parados. Clique para ver só os parados.'
      }
      onClick={() => onChange(!held)}
    >
      Parados
    </Button>
  );
}
